<template>
  <div class="hn-main">
    <div class="hn-header">
      <img :src="itemDetail.icon||'https://oss.mcloud.moveclub.cn/movexcxstore/20210617/2y5riGXwsc.png'" alt="">
    </div>
    <div class="float" v-if="banner.jumpurl" @click="goto(banner)">可以进行点赞了哦！</div>
    <div class="hn-body">
      <div class="hn-point" @click="goto(banner)"><img :src="banner.imgurl" alt=""></div>
      <div class="hn-btn" @click="go"><img src="https://oss.mcloud.moveclub.cn/mpms/20210608/1623137722-60bf1dbac6767.png" alt=""></div>
      <div class="hn-tab">
        <div @click="show=true"><img src="https://oss.mcloud.moveclub.cn/mpms/20210608/1623140588-60bf28ec8494f.png" alt=""></div>
        <div @click="gorank"><img src="https://oss.mcloud.moveclub.cn/mpms/20210608/1623140580-60bf28e4c3cfe.png" alt=""></div>
      </div>
    </div>
    <div class="hn-footer">
      <div class="hn-ttt">{{itemDetail.notice}}</div>
      <div class="hn-one">{{ count[0]}}</div>
      <div class="hn-two">{{ count[1] }}</div>
    </div>
    <van-overlay z-index="1000" :show="show" :lock-scroll="false">
      <div class="wrapper">
        <van-icon class="close" size=".4rem" name="close" @click="show = false" />
        <div class="block" v-html="itemDetail.rules"></div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import moment from "moment";
import {mapMutations} from "vuex";
import "./index.less";
import {Overlay} from 'vant'

export default {
  name: "index.vue",
  props: ["sports_id"],
  data() {
    return {
      show: false,
      itemDetail: {},
      banner: {},
      detail: {},
      count: []
    };
  },
  components: {
    VanOverlay: Overlay
  },
  methods: {
    ...mapMutations(["toggleShowFill"]),
    go() {
      this.$router.push({name:'bn_care',params:{item_sub_id: 2488, sports_id:this.sports_id}})
    },
    gorank() {
      this.$router.push({name:'bn_rank',params:{item_sub_id: 2488, sports_id:this.sports_id}})
    },
    goto(item) {
      if(item.jumpurl){
        this.$router.push({name:'bn_care',params:{item_sub_id:item.jumpurl, sports_id:this.sports_id}})
      }
    },
    getState() {
      return new Promise((resolve, reject) => {
        this.$api.bainian.userState().then((res)=>{
          if(res.status === 200){
            resolve(res.data)
          }else{
            reject(res)
          }
        })
      })
    },
    async init() {

      const data = await this.getState();
      if(!data.current){
        this.$api.common.getBanners({position:13,app:123}).then((res)=>{
          this.banner = res.data[0];
        })
      }else{

      }

      this.$toast.loading({
        duration: 0,
      });
      // data.current = data.current?data.current:{id:this.banner.jumpurl}
      let params = { cpgid: 2488 };
      let count = []
      if(data.count.length===1){
        count[0] = 0
        count[1] = data.count
      }else{
        count = data.count.split('')
      }
      this.count = count
      this.detail = data
      Promise.all([
        this.$api.sports.sportsMain(this.sports_id),
        this.$api.sports.getComparegame(params),
        this.$api.common.getBanners({position:13,app:123}),
      ]).then(
          (res) => {
            let { start_time, end_time, sex_limit, age_limit, today_state } = res[1]["data"];
            start_time = moment(start_time).valueOf();
            end_time = moment(end_time).valueOf();
            var sys_time = res[1]["sys_time"] * 1000;
            let tips,
                disabled = true,
                notice;
            // if(this.detail.today_state == 0){
            //   notice = '今日还未上传轨迹图哦！'
            // }else{
            //   notice = '今日您已上传了！'
            // }
            notice = '上传已结束！'
            if (sys_time < start_time) {
              tips = "活动未开始";
            } else if (sys_time > end_time) {
              tips = "活动已结束";
            } else {
              tips = "立即参与";
              disabled = false;
            }
            this.itemDetail = Object.assign(res[1]["data"], { tips, disabled, notice });
            this.banner = res[2].data[0];
            this.$toast.clear();
            //判断 是否需要 限制性别 或生日 如果需要则要填写信息
            if (+sex_limit !== 0 || +age_limit !== 0) {
              let { name, phone, id_number } = this.getOnlyUserInfo;

              console.log(name);
              console.log(phone);
              console.log(id_number);

              if (!!name && !!phone && !!id_number) {
              } else {
                //需要补全信息
                this.toggleShowFill(true);
                return;
              }
            }
          },
          () => {
            this.$toast.clear();
          }
      );
    },
  },
  mounted() {
    this.init();
    this.cf.wxShareConf();
  },
}
</script>

<style scoped>

</style>
